import { SUBDOMAIN_REG_EXP } from '../../constants/regex.constants';

export const getWebsiteFieldValidationError = (subdomain: string): string[] | null => {
    if (subdomain && !subdomain?.match(SUBDOMAIN_REG_EXP)) {
        return ['- The subdomain must only contain valid characters: a-z (lowercase only), 0-9, and hyphen/dash ("-").',
            '- The subdomain must not begin or end with a hyphen/dash.',
            '- The subdomain must be between 3 and 63 characters.'];
    }
    return null;
};
